import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '@br/mg-components';

const useStyles = (radioButtonError: boolean) => {
    const theme = useWolfTheme();
    return useMemo(
        () => ({
            radioButton: css({
                '.vn-radio-button__icon': {
                    ...(radioButtonError && {borderColor: `${theme.palette.negative.default} !important`}),
                },
            }),
        }),
        [theme.palette.negative.default, radioButtonError]
    );
};

export default useStyles;
